import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-placeholder" }

import { ScryfallCard, ScryfallCardFace } from "../vueCardCache";
import CardText from "./CardText.vue";
import { Card, CardFace } from "@/CardTypes";


export default /*@__PURE__*/_defineComponent({
  __name: 'CardPlaceholder',
  props: {
    card: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.card)
      ? (_openBlock(), _createBlock(CardText, {
          key: 0,
          class: "alt-card-text",
          card: __props.card!,
          delayTextFit: true
        }, null, 8 /* PROPS */, ["card"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})